import { Component, Input, OnInit } from "@angular/core";
import { GraphicsInfoScaleField } from "../../../../domain/graphics-info";

@Component({
  selector: "icn-graphics-scale",
  templateUrl: "./scale.component.html",
  styleUrls: ["./scale.component.scss"],
})
export class GraphicsScaleComponent implements OnInit {
  selectedValue: number;
  constructor() {}

  @Input() scaleField: GraphicsInfoScaleField;

  onValueChange(newVal: number) {
    this.selectedValue = newVal;
    this.scaleField.value = newVal / 100;
    console.log("onValueChange->", newVal, this.scaleField.value);
  }

  ngOnInit(): void {
    this.selectedValue = parseFloat((this.scaleField.value * 100).toFixed(3));
  }
}
